import { AiOutlinePlus } from 'react-icons/ai';

import { Form } from 'formik';
import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

interface GroupButtonProps {
  marginBottom?: boolean;
}

interface InfoContainerProps {
  type: 'leftBottom' | 'rightBottom' | 'leftTop' | 'rightTop';
}

export const PaddingContainer = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  padding: 45px 16px 0 16px;
  position: relative;

  @media ${({ theme }) => theme.device.desktop} {
    width: 600px;
    margin: 0 auto;
    padding: 0;
  }
`;

export const PaddingContainerNoMargin = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 16px;
  position: relative;

  @media ${({ theme }) => theme.device.desktop} {
    width: 600px;
    margin: 0 auto;
    padding: 0;
  }
`;

export const FragmentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    min-height: calc(100vh - 84px);
  }
`;

export const Header = styled.header`
  margin-bottom: 32px;

  > h3 {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.1px;
    color: #ff6d48;

    @media ${({ theme }) => theme.device.desktop} {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.2px;
    }
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 494px;
    align-self: center;
    text-align: center;
    margin-top: 80px;
  }
`;

export const HeaderCenter = styled.header`
  margin-bottom: 32px;
  > h3 {
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.1px;
    color: #ff6d48;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 64px;
  }
`;

export const Subtitle = styled.h4`
  margin-top: 24px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};

  > strong {
    font-weight: bold;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const StyledForm = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 auto;
  }
`;

export const BottomBackgroundDesktop: any = styled.div`
  min-height: 310px;
  max-height: 310px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column-reverse;
  background-image: url('/images/onboarding/oval-bottom-desktop.svg');

  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;

  @media screen and (max-height: 700px) {
    display: none;
  }

  @media screen and (max-height: 900px) {
    min-height: 25vh;
    max-height: 25vh;
  }
`;

BottomBackgroundDesktop.Description = styled.p`
  margin-bottom: 111px;
  position: absolute;
  max-width: 500px;
  margin-top: 32px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: center;
  color: ${ColorPalette.HEX.White};

  @media screen and (max-height: 900px) {
    margin-bottom: 5vh;
    max-width: 400px;
    font-size: 14px;
  }
`;

BottomBackgroundDesktop.Image = styled.div`
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;

  @media screen and (max-height: 900px) {
    & > img {
      height: 15vh;
    }
  }
`;

export const BottomBackground: any = styled.div`
  background-image: url('/images/onboarding/oval.svg');
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  max-height: 350px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

BottomBackground.Description = styled.p`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.White};
  width: 80%;
  margin: 32px auto;
`;

BottomBackground.Image = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -75px;
`;

export const BottomReviewBackground = styled.div`
  min-height: 194px;
  margin-top: 10px;
  background-image: url('/images/onboarding/group-8.png');
  background-size: 218%;
  display: flex;
  flex-direction: column-reverse;
  background-repeat: no-repeat;
  background-position: center top;
  flex: 1 1 0%;
`;

export const BottomReviewImage = styled.img`
  max-width: min(1440px, 100%);
  margin: 32px auto 0 auto;
`;

export const BottomEndBackground = styled.div`
  min-height: 470px;
  margin-top: 10px;
  background-image: url('/images/onboarding/group-2.svg');
  background-repeat: no-repeat;
  background-position: top;
  flex-direction: column;
  align-items: center;
  display: flex;
  flex: 1;

  > p {
    padding: 0 66px;
    margin-top: 268px;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: ${ColorPalette.HEX.White};
  }

  @media ${({ theme }) => theme.device.desktop} {
    position: relative;
    background-image: url('/images/onboarding/group-2-desktop.png');
    background-size: cover;
    min-height: min(532px, 37vw);
    width: min(1440px, 100%);
    margin: 0 auto;

    > p {
      position: absolute;
      bottom: min(115px, 8vw);
      margin: 0;
      padding: 0;
      max-width: 300px;
    }
  }
`;

export const GroupButton = styled.div<GroupButtonProps>`
  padding: 0 16px;
  margin-top: 16px;
  margin-bottom: 32px;
  flex: 1;
  display: flex;
  flex-direction: column-reverse;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 600px;
    align-self: center;
    width: 100%;
    justify-content: flex-end;
    margin: ${({ marginBottom }) => (marginBottom ? '0 0 64px 0' : '32px 0 32px 0')};
    padding: 0;
  }
`;

export const ButtonNext = styled(Button)`
  background: ${ColorPalette.Transparent};
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.OriolesOrange};
`;

export const TransitionContainer = styled.div`
  display: flex;
  flex-direction: column;

  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-leave.fade-leave-active {
    opacity: 0.01;
    transition: opacity 150ms ease-in;
  }

  span {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: absolute;
  width: 100%;
  background: ${ColorPalette.HEX.White};

  @media ${({ theme }) => theme.device.desktop} {
    position: static;
    height: auto;
  }
`;

export const UsersContainer = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
`;

const infoVariations = {
  leftBottom: css`
    border-radius: 16px 16px 16px 0px;
  `,
  rightBottom: css`
    border-radius: 16px 16px 0px 16px;
  `,
  leftTop: css`
    border-radius: 0px 16px 16px 16px;
  `,
  rightTop: css`
    border-radius: 16px 0px 16px 16px;
  `,
};

export const SpecificInfoContainer = styled.div`
  width: 100%;
  max-width: 258px;
  @media (max-width: 320px) {
    max-width: 194px;
  }

  @media (min-width: 321px) and (max-width: 360px) {
    max-width: 239px;
  }
`;

export const InfoContainer = styled.div<InfoContainerProps>`
  margin-top: 16px;
  max-width: 90%;
  width: fit-content;
  min-height: fit-content;
  display: flex;
  border-radius: 0px 16px 16px 16px;

  ${(props: InfoContainerProps) => infoVariations[props.type]}

  background-color: #ff6d48;

  p {
    padding: 10px 9px 14px 16px;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.White};
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 0;
  }
`;

export const ApproverInfoContainer = styled.div`
  height: 220px;
  position: relative;

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 16px;
    height: 300px;
  }

  img {
    margin-top: 16px;
    margin-left: -8px;

    @media ${({ theme }) => theme.device.desktop} {
      height: 258px;
      margin: 0;
    }
  }

  div {
    position: absolute;
    right: 0;
    top: 0;

    @media ${({ theme }) => theme.device.desktop} {
      left: 100px;
    }
  }
`;

export const ReviewContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  border-radius: 12px;
  border: solid 1px #e4e9ee;
  background-color: ${ColorPalette.HEX.White};
  padding: 17px 16px 20px 48px;

  & + div {
    margin-top: 16px;
  }

  > h3 {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.CharlestonGreen};
  }

  > h2 {
    font-family: Poppins;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.1px;
    color: ${ColorPalette.HEX.CharlestonGreen};
    margin-bottom: 13px;
  }
`;

export const IconReview = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 24px;
    height: 24px;
  }
`;

export const InfoRulesReview = styled.div`
  display: flex;
  flex-direction: column;

  &:before {
    content: ' ';
    border-bottom: solid 1px #e4e9ee;
    margin-bottom: 22px;
  }

  h4 {
    padding-bottom: 16px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.CharlestonGreen};
  }

  > p {
    font-family: Poppins;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.DimGray};
    display: flex;
    flex-direction: row;
    padding: 0px;

    &:last-child {
      margin-bottom: 22px;
    }

    > strong {
      text-align: right;
      font-weight: bold;
      flex: 1;
    }
  }
`;

export const AggregationIcon = styled(AiOutlinePlus)`
  height: 16px;
  width: 16px;
  color: ${ColorPalette.HEX.DimGray} !important;
`;
